import { Component, Input, OnInit } from '@angular/core';
import { DirectService } from 'src/app/shared/services/user/direct.service';

@Component({
  selector: 'app-seller-direct',
  templateUrl: './seller-direct.component.html',
  styleUrls: ['./seller-direct.component.scss'],
})
export class SellerDirectComponent implements OnInit {
  @Input() id: any;
  @Input() origin: any;
  directClient: any[] = [];
  directNav: any;
  directFooter: any;
  directBlackBox: any;
  copyrightYear = new Date().getFullYear();
  constructor(private directService: DirectService) {}

  ngOnInit() {
    this.getDirectClient();
  }

  private getDirectClient() {
    let param = {};
    if (this.id) {
      param = { id: this.id, origin: this.origin };
    }
    this.directService.getDirectClient$(param).subscribe(result => {
      this.directClient = result.data;
      this.directNav = this.directClient.find(
        x => x.block_type === 'navigation',
      );
      this.directFooter = this.directClient.find(
        x => x.block_type === 'footer',
      );
      this.directBlackBox = this.directClient.find(
        x => x.block_type === 'blackbox',
      );
    });
  }
}
